"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _errorMessageModule = _interopRequireDefault(require("./error-message.module.scss"));
var _fieldsize = _interopRequireWildcard(require("./fieldsize"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Form messages
// =============

const ErrorMessage = _ref => {
  let {
    size,
    message,
    className,
    ariaLive
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_errorMessageModule.default.ErrorMessage, {
      [_errorMessageModule.default.ErrorMessageDefault]: size === _fieldsize.default.DEFAULT,
      [_errorMessageModule.default.ErrorMessageSmall]: size === _fieldsize.default.SMALL
    }, className),
    "aria-live": ariaLive
  }, message);
};
ErrorMessage.defaultProps = {
  ..._fieldsize.fieldSizeDefaultProps,
  ariaLive: 'polite'
};
ErrorMessage.propTypes = {
  ..._fieldsize.fieldSizePropTypes,
  message: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  ariaLive: _propTypes.default.oneOf(['off', 'polite', 'assertive'])
};
var _default = exports.default = ErrorMessage;